<template>
  <div
    class="dialog_overlay"
    v-if="visible"
  >
    <div class="dialog_container flex-col">
      <span class="title_text">教师评分及评语</span>
      <span class="rating_label">教师评分&nbsp;(-1&nbsp;为未评分)</span>
      <div class="rating_input_container flex-col justify-end">
        <input
          class="rating_input"
          type="number"
          v-model="rating"
        />
      </div>
      <span class="comment_label">教师评语</span>
      <div class="comment_input_container flex-col">
        <textarea
          class="comment_input"
          v-model="comment"
        ></textarea>
      </div>
      <div class="button_group flex-row justify-between">
        <div
          class="submit_button flex-col"
          @click="handleSubmit"
        >
          <span class="submit_text">提交</span>
        </div>
        <div
          class="cancel_button flex-col"
          @click="handleCancel"
        >
          <span class="cancel_text">取消</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps, defineEmits, watch } from "vue"

// 定义props
const props = defineProps({
  visible: {
    type: Boolean,
    required: true,
    default: false,
  },
  initialRating: {
    type: Number,
    default: -1,
  },
  initialComment: {
    type: String,
    default: "",
  },
})

// 定义emits
const emit = defineEmits(["update-visible", "submit"])

// 评分和评语数据
const rating = ref(props.initialRating)
const comment = ref(props.initialComment)

// 处理提交
const handleSubmit = () => {
  // 简单验证
  if (isNaN(rating.value)) {
    alert("请输入有效的评分")
    return
  }

  // 提交数据
  emit("submit", {
    rating: rating.value,
    comment: comment.value,
  })

  // 关闭弹窗
  emit("update:visible", false)
}

// 处理取消
const handleCancel = () => {
  emit("update-visible", false)
}

// 监听visible变化，重置表单
watch(
  () => props.visible,
  (newVal) => {
    if (newVal) {
      rating.value = props.initialRating
      comment.value = props.initialComment
    }
  }
)
</script>

<style scoped>
.dialog_overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 99;
}

.dialog_container {
  background-color: rgba(234, 238, 242, 1);
  border-radius: 24px;
  width: 33.34vw;
  height: 22.45vw;
  margin: 0;
}

.title_text {
  width: 8.75vw;
  height: 1.57vw;
  overflow-wrap: break-word;
  color: rgba(34, 76, 123, 1);
  font-size: 1.25vw;
  font-family: Microsoft YaHei UI-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 1.25vw;
  margin: 1.14vw 0 0 12.29vw;
}

.rating_label {
  width: 10.73vw;
  height: 1.31vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei UI-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
  margin: 1.3vw 0 0 2.81vw;
}

.rating_input_container {
  background-color: rgba(255, 255, 255, 1);
  border-radius: 4px;
  width: 27.4vw;
  height: 1.67vw;
  margin: 0.46vw 0 0 2.81vw;
  border-top: 1px solid rgba(199, 199, 199, 1);
  border-left: 1px solid rgba(199, 199, 199, 1);
  border-right: 1px solid rgba(199, 199, 199, 1);
  border-bottom: 1px solid rgba(0, 0, 0, 1);
}

.helper_text {
  width: 0.73vw;
  height: 1.05vw;
  overflow-wrap: break-word;
  color: rgba(112, 112, 112, 1);
  font-size: 0.72vw;
  font-family: Segoe UI-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
  margin: 0.26vw 0 0 0.62vw;
}

.rating_input {
  color: rgba(112, 112, 112, 1);
  font-size: 0.72vw;
  font-family: Segoe UI-Regular;
  border: none;
  outline: none;
  height: 1.6vw;
  line-height: 1.6vw;
  background-color: transparent;
}

.divider_line {
  background-color: rgba(87, 87, 87, 1);
  width: 27.4vw;
  height: 0.06vw;
  margin-top: 0.32vw;
}

.comment_label {
  width: 4.17vw;
  height: 1.31vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei UI-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
  margin: 1.4vw 0 0 2.81vw;
}

.comment_input_container {
  background-color: rgba(255, 255, 255, 1);
  border-radius: 4px;
  height: 5.84vw;
  border-top: 1px solid rgba(199, 199, 199, 1);
  border-left: 1px solid rgba(199, 199, 199, 1);
  border-right: 1px solid rgba(199, 199, 199, 1);
  border-bottom: 1px solid rgba(0, 0, 0, 1);
  width: 27.4vw;
  margin: 0.41vw 0 0 2.81vw;
}

.comment_input {
  resize: none;
  color: rgba(112, 112, 112, 1);
  font-size: 0.72vw;
  font-family: Segoe UI-Regular;
  border: none;
  outline: none;
  height: 5.84vw;
  line-height: 1vw;
  background-color: transparent;
}

.comment_divider {
  background-color: rgba(87, 87, 87, 1);
  width: 27.4vw;
  height: 0.06vw;
  margin-top: 5.79vw;
}

.button_group {
  width: 16.36vw;
  height: 2.77vw;
  margin: 2.03vw 0 1.25vw 8.48vw;
}

.submit_button {
  background-color: rgba(55, 91, 165, 1);
  border-radius: 4px;
  height: 2.71vw;
  width: 6.88vw;
  cursor: pointer;
}

.submit_text {
  width: 2.09vw;
  height: 1.05vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 1.04vw;
  font-family: Segoe UI-Semibold;
  font-weight: 600;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
  margin: 0.78vw 0 0 2.39vw;
}

.cancel_button {
  background-color: rgba(104, 162, 250, 1);
  border-radius: 4px;
  height: 2.71vw;
  margin-top: 0.06vw;
  width: 6.88vw;
  cursor: pointer;
}

.cancel_text {
  width: 2.09vw;
  height: 1.05vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 1.04vw;
  font-family: Segoe UI-Semibold;
  font-weight: 600;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
  margin: 0.78vw 0 0 2.39vw;
}
</style>
